export default "__VITE_PUBLIC_ASSET__59858c8f__"